import axios from "axios";

export const state = {
    onlinetransactions: [],
    withdrawnAmount: 0
};

export const getters = {
    onlinetransactions: (state) => state.onlinetransactions,
    withdrawnAmount: (state) => state.withdrawnAmount
};

export const mutations = {
    setOnlineTransactions(state, newValue) {
        state.onlinetransactions = newValue;
    },
    setWithdrawnAmount(state, newValue) {
        state.withdrawnAmount = newValue;
    }
};

export const actions = {
    async fetchOnlineTransactions({ commit }) {
        await axios.get("/online-transactions").then((res) => {
            commit("setOnlineTransactions", res.data.online_transactions);
            commit("setWithdrawnAmount", res.data.withdrawn);
        });
    },
};
